import { useWidget } from '@telescope/cassini-hooks';
import { Box, Button } from '@telescope/cassini-ui';
import { GenericObject } from '@telescope/cassini-utilities';
import { Open } from 'generated-types/widget';
import React from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { useAuth } from '../lib';
import { AuthMethod, renderInput } from '../utils';

interface RegisterFormStep2Props {
  onFormSubmit(formData: GenericObject): void;
  defaultValues?: GenericObject;
}
export const RegisterFormStep2 = ({ onFormSubmit, defaultValues = {} }: RegisterFormStep2Props) => {
  const { isRegistering } = useAuth();
  const { data } = useWidget<Open>({ select: (data) => data.widget.globalViews.auth });
  const formMethods = useForm<{ [x: string]: any }>({
    mode: 'onSubmit',
    reValidateMode: 'onChange',
    defaultValues,
  });
  const { handleSubmit } = formMethods;
  const content = data.content.registrationModal;
  const { isMethodEnabled } = useAuth();

  const handleCompleteRegistration = () => {
    handleSubmit(onFormSubmit)();
  };

  return (
    <FormProvider {...formMethods}>
      <form onSubmit={(e) => e.preventDefault()}>
        <Box>
          {/* Email */}
          {isMethodEnabled(AuthMethod.EMAIL) && (
            <Box>
              {renderInput({
                ...content.emailInput,
                isDisabled: defaultValues.user_email,
              })}
              {content.inputs.map((field: any, index: number) => {
                return <React.Fragment key={index}>{renderInput({ ...field })}</React.Fragment>;
              })}
              {content.optins.map((field: any, index: number) => {
                return <React.Fragment key={index}>{renderInput({ ...field })}</React.Fragment>;
              })}
              <Button isLoading={isRegistering} width="full" type="button" mb={3} onClick={handleCompleteRegistration}>
                {content.continueButton}
              </Button>
            </Box>
          )}
        </Box>
      </form>
    </FormProvider>
  );
};
